import { X } from 'lucide-react'
import { ActiveFilter } from './filterTypes'

interface FilterChipProps {
  filter: ActiveFilter
  onRemove: (filterId: string) => void
}

export function FilterChip({ filter, onRemove }: FilterChipProps) {
  return (
    <div
      className="inline-flex items-center gap-1.5 px-2.5 py-1 bg-primary text-primary-content text-xs rounded-md shadow-sm"
      data-testid={`filter-chip-${filter.field}`}
    >
      <span className="font-medium">{filter.fieldLabel}</span>
      <span className="opacity-90">{filter.operatorLabel}</span>
      <span className="font-semibold">&quot;{filter.valueLabel}&quot;</span>
      <button
        type="button"
        onClick={() => onRemove(filter.id)}
        className="ml-1 hover:bg-base-content/20 rounded-full p-0.5 transition-colors cursor-pointer"
        aria-label="Remove filter"
        data-testid={`filter-chip-remove-${filter.field}`}
      >
        <X className="w-3 h-3" />
      </button>
    </div>
  )
}
